module.exports = __webpack_public_path__ + "static/media/engagement.212978fd.svg";